/* eslint-disable array-callback-return */
import { useState, useEffect } from "react";
import Chart from "react-google-charts";
import NumberFormat from "react-number-format";
import { TableCell, TableFooter, TableRow } from "@material-ui/core";
import MaterialTable, { MTableBody } from "material-table";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  Box,
  useMediaQuery,
  CircularProgress,
  FormControl,
  FormLabel,
  Text,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { default as ReactSelect } from "react-select";
import makeAnimated from "react-select/animated";
import api from "services/api";
import Swal from "sweetalert2";
import { tableIcons } from "utils/tableIcons";
import moment from "moment";
import { meses } from "utils/meses";
import { Link } from "react-router-dom";
import { sortASCStatus } from "utils/sort";

const movimentationType = [
  { value: 1, label: "Cobrança" },
  { value: 2, label: "Repasse de Taxas" },
];

const defaultStatus = [
  { id: 1, name: "Não enviado", qtd: 0 },
  { id: 2, name: "Enviado. Aguardando validação", qtd: 0 },
  { id: 3, name: "Negado. Aguardando reenvio", qtd: 0 },
  { id: 4, name: "Aceito", qtd: 0 },
  { id: 5, name: "Boleto e Nota disponíveis", qtd: 0 },
  { id: 8, name: "Validado com pendência", qtd: 0 },
  { id: 9, name: "Fatura enviada", qtd: 0 },
  { id: 10, name: "Nota disponível", qtd: 0 },
  { id: 11, name: "Nota excluída. Aguardando reenvio", qtd: 0 },
  { id: -1, name: "Todos", qtd: 0 },
];

const colorsChart = [
  { id: 1, color: "#DD6B20" },
  { id: 2, color: "#9cc3d8" },
  { id: 3, color: "#E53E3E" },
  { id: 4, color: "#38A169" },
  { id: 5, color: "#3182CE" },
  { id: 8, color: "#e59462" },
  { id: 9, color: "#3182CE" },
  { id: 10, color: "#38A169" },
  { id: 11, color: "#DD6B20" },
];

type Document = [
  {
    id: number;
    operadora: {
      id: number;
      nm_operadora: string;
    };
    entidade: {
      id: number;
      nm_entidade: string;
    };
    status_documento: {
      id: number;
      status: string;
    };
    valor: number;
    dt_vencimento: string;
    contrato: {
      id: number;
      dia_limite_ext_bol_not: boolean;
    };
    ano_competencia: number;
    mes_competencia: number;
    fl_pendencia_ext_bol_not: boolean;
    tipo_documento: any;
  },
];

const PainelControleInter = () => {
  const animatedComponents = makeAnimated();
  const [mobile] = useMediaQuery("(max-width: 624px)");
  const [documents, setDocuments] = useState<Document | []>([]);
  const [pageLoading, setPageLoading] = useState<boolean>(true);
  const [chartLoading, setChartLoading] = useState<boolean>(false);
  // const [totalValue, setTotalValue] = useState<any>();
  const [years, setYears] = useState<any>();
  const [months, setMonths] = useState<any>();
  const [pessoasJuridicas, setPessoasJuridicas] = useState<any>();
  const [statusValue, setStatusValue] = useState<any>();
  const [operadoras, setOperadoras] = useState<any>();
  const [status, setStatus] = useState<any>(defaultStatus);
  // const [hoveringOver, setHoveringOver] = useState("");
  // const handleRowHover = (event: any, propsData: any) => {
  //   setHoveringOver(propsData.data.id);
  // };
  // const handleRowHoverLeave = (event: any, propsData: any) =>
  //   setHoveringOver("");

  const exportPDF = (data: any, columns: any) => {
    const head = [data.map((doc: any) => doc.title)];

    let arrayData: any[] = [];

    columns.map((doc: any) => {
      arrayData.push([
        doc?.entidade?.nm_entidade,
        doc?.operadora?.nm_operadora,
        meses[doc?.mes_competencia - 1],
        doc?.ano_competencia,
        doc?.valor &&
          doc?.valor.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          }),
        doc?.status_documento?.status,
        doc?.dt_vencimento,
      ]);
    });

    const valorTotal = columns
      .reduce((total: any, valor: any) => total + valor.valor, 0)
      .toLocaleString("pt-br", { style: "currency", currency: "BRL" });

    arrayData.push(["", "", "", "TOTAL", valorTotal, "", ""]);

    const doc = new jsPDF("landscape");
    autoTable(doc, {
      head: head,
      body: arrayData,
      willDrawCell: function (data) {
        var rows = data.table.body;
        if (data.row.index === rows.length - 1) {
          doc.setFillColor(49, 130, 206);
          doc.setFontSize(13);
          doc.setTextColor("white");
        }
      },
    });

    doc.save("table.pdf");
  };

  const qtdStatus = (array: [], status: number | null, tipo: any) => {
    let status_boleto_disponivel = 0;

    array.map((doc: any) => {
      if (
        doc?.tipo_documento === tipo &&
        doc?.status_documento?.id === status
      ) {
        status_boleto_disponivel++;
      }
      return status_boleto_disponivel;
    });
    return status_boleto_disponivel;
  };

  const pjData = (pjData: any, tipo: any) => {
    setStatus([
      {
        ...status[0],
        qtd: qtdStatus(pjData, 1, tipo),
      },
      {
        ...status[1],
        qtd: qtdStatus(pjData, 2, tipo),
      },
      {
        ...status[2],
        qtd: qtdStatus(pjData, 3, tipo),
      },
      {
        ...status[3],
        qtd: qtdStatus(pjData, 4, tipo),
      },
      {
        ...status[4],
        qtd: qtdStatus(pjData, 5, tipo),
      },
      {
        ...status[5],
        qtd: qtdStatus(pjData, 8, tipo),
      },
      {
        ...status[6],
        qtd: qtdStatus(pjData, 9, tipo),
      },
      {
        ...status[7],
        qtd: qtdStatus(pjData, 10, tipo),
      },
      {
        ...status[8],
        qtd: qtdStatus(pjData, 11, tipo),
      },
      {
        ...status[9],
        qtd: 1,
      },
    ]);
  };

  async function getDocuments(tipo: number) {
    setChartLoading(true);
    try {
      const response = await api.get("/documentos?_sort=id:DESC");

      const data = response.data
        .filter((cont: any) => cont.tipo_documento === tipo)
        .filter((cont: any) => cont?.contrato?.fl_ativo)
        .filter((cont: any) => cont?.status_documento);
      let arrayData: any = [];

      data.map((doc: any) => {
        arrayData.push({
          ...doc,
          dt_vencimento: moment(doc.dt_vencimento).format("DD/MM/YYYY"),
        });
      });

      // setTotalValue(
      //   arrayData
      //     .reduce((total: any, valor: any) => total + valor.valor, 0)
      //     .toLocaleString("pt-br", { style: "currency", currency: "BRL" }),
      // );

      setDocuments(arrayData.sort(sortASCStatus));
      pjData(data, tipo);

      const reduced = (
        data: any,
        atributo: string,
        state: (value: any) => void,
        mes: boolean,
        atributoExtra: any,
      ) => {
        const reducedYear: any[] = [];
        data.forEach((doc: any) => {
          let duplicated =
            reducedYear.findIndex((item: any) => {
              if (atributoExtra === "status") {
                return (
                  doc?.status_documento?.status ===
                  item?.status_documento?.status
                );
              } else if (atributoExtra === "nm_entidade") {
                return (
                  doc?.entidade?.nm_entidade === item?.entidade?.nm_entidade
                );
              } else if (atributoExtra === "nm_operadora") {
                return (
                  doc?.operadora?.nm_operadora === item?.operadora?.nm_operadora
                );
              } else if (!atributoExtra) {
                return doc?.[atributo] === item?.[atributo];
              }
            }) > -1;
          if (!duplicated) {
            return reducedYear.push(!atributoExtra ? doc : doc?.[atributo]);
          }
          return reducedYear;
        });
        let obj = {};

        reducedYear.map((doc: any) => {
          if (!atributoExtra) {
            Object.assign(obj, {
              [doc?.[atributo]]: mes
                ? meses[doc?.[atributo] - 1]
                : doc?.[atributo],
            });
          } else {
            Object.assign(obj, {
              [doc?.id]: doc?.[atributoExtra],
            });
          }
        });
        state(obj);
      };

      reduced(data, "ano_competencia", setYears, false, false); // Filtro ANO
      reduced(data, "mes_competencia", setMonths, true, false); // Filtro MÊS
      reduced(data, "status_documento", setStatusValue, false, "status"); // Filtro MÊS
      reduced(data, "operadora", setOperadoras, false, "nm_operadora"); // Filtro OPERADORA
      reduced(data, "entidade", setPessoasJuridicas, false, "nm_entidade"); // Filtro PESSOA JURÍDICA

      setPageLoading(false);
    } catch (err) {
      console.log(err);
      setPageLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro ao listar as Competências",
        showConfirmButton: true,
        confirmButtonText: `Ok`,
      });
    }
    setChartLoading(false);
  }

  const handleType = (selectedOption: any) => {
    getDocuments(selectedOption.value);
  };

  const statusData = (data: any) => {
    let array = [["Status", "Quantidade"]];

    data.map((item: any) =>
      array.push([`${item?.name}: ${item?.qtd}`, item?.qtd]),
    );

    return array;
  };

  useEffect(() => {
    getDocuments(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (pageLoading) {
    return (
      <Box
        as="section"
        display="flex"
        w="100%"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress isIndeterminate color="blue.200" />
      </Box>
    );
  }

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        margin="30px"
        gridRowGap="15px"
        position="relative"
      >
        <Box
          display="flex"
          flexDirection={mobile ? "column" : "row"}
          gridGap="15px"
          width="300px"
          height="max-content"
          maxWidth="100%"
          padding="12px"
          backgroundColor="#fff"
          boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
        >
          <FormControl>
            <FormLabel htmlFor="type">Tipo de movimentação:</FormLabel>
            <ReactSelect
              className="basic-single"
              classNamePrefix="select"
              closeMenuOnSelect={true}
              isSearchable={true}
              // placeholder="Selecione um tipo de movimentação"
              noOptionsMessage={() => "-"}
              onChange={handleType}
              defaultValue={{
                value: 1,
                label: "Cobrança",
              }}
              options={movimentationType.map((mov) => ({
                value: mov.value,
                label: mov.label,
              }))}
              components={animatedComponents}
            />
          </FormControl>
        </Box>

        <Box
          display="flex"
          flexDirection={mobile ? "column" : "row"}
          gridGap="15px"
          width="100%"
          backgroundColor="#fff"
          boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
        >
          {documents.length > 0 ? (
            <>
              {chartLoading ? (
                <Box
                  as="section"
                  display="flex"
                  w="100%"
                  height="300px"
                  justifyContent="center"
                  alignItems="center"
                >
                  <CircularProgress isIndeterminate color="blue.200" />
                </Box>
              ) : (
                <Box display="flex">
                  <Chart
                    width={"830px"}
                    height={"300px"}
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={statusData(status.filter((el: any) => el?.id !== -1))}
                    options={{
                      // title: `Total: ${Object.values(status)
                      //   .filter((el: any) => el.id !== -1)
                      //   .reduce(
                      //     (a: any, b: any) => parseInt(a) + parseInt(b.qtd),
                      //     0,
                      //   )}`,
                      titleTextStyle: {
                        fontSize: 16,
                      },
                      is3D: true,
                      pieSliceText: "value",
                      // chartArea: { left: 0 },
                      colors: colorsChart.map((color: any) => color.color),
                      legend: {
                        alignment: "center",
                        position: "left",
                        textStyle: { color: "blue", fontSize: 15 },
                      },
                    }}
                    rootProps={{ "data-testid": "1" }}
                  />
                  {/* <Box
                    width="100%"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                  >
                    <Text fontWeight="500" fontSize="1.2rem">
                      Valor total:
                    </Text>
                    <Text
                      backgroundColor="#e2e8f0"
                      padding="10px"
                      fontSize="1.5rem"
                      fontWeight="500"
                      color="rgb(45, 136, 87)"
                    >
                      {" "}
                      {totalValue}
                    </Text>
                  </Box> */}
                </Box>
              )}
            </>
          ) : (
            <Alert status="info">
              <AlertIcon />
              Nenhum dado cadastrado
            </Alert>
          )}
        </Box>

        {documents.length > 0 && (
          <Box as="form" zIndex="0">
            <MaterialTable
              icons={tableIcons}
              title=""
              data={documents}
              components={{
                Body: (props) => (
                  <>
                    <MTableBody {...props} />
                    <TableFooter>
                      <TableRow>
                        <TableCell colSpan={4} />
                        <TableCell colSpan={1}>
                          <Box
                            display="flex"
                            fontSize="20px"
                            fontWeight="500"
                            color="#212529"
                          >
                            Total:{" "}
                            {props.renderData
                              .reduce(
                                (total: any, valor: any) => total + valor.valor,
                                0,
                              )
                              .toLocaleString("pt-br", {
                                style: "currency",
                                currency: "BRL",
                              })}
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableFooter>
                  </>
                ),
              }}
              // components={{
              //   Row: (props) => {
              //     return (
              //       <MTableBodyRow
              //         {...props}
              //         onMouseEnter={(e: any) => handleRowHover(e, props)}
              //         onMouseLeave={(e: any) => handleRowHoverLeave(e, props)}
              //       />
              //     );
              //   },
              // }}
              localization={{
                body: {
                  emptyDataSourceMessage: "Nenhum dado cadastrado.",
                },
                pagination: {
                  labelDisplayedRows: "{from}-{to} de {count}",
                  labelRowsSelect: "linhas",
                  previousTooltip: "Página anterior",
                  nextTooltip: "Próxima página",
                  firstTooltip: "Primeira página",
                  lastTooltip: "Última página",
                },
                toolbar: {
                  searchPlaceholder: "Buscar",
                  exportTitle: "Exportar",
                  exportAriaLabel: "Exportar",
                  exportCSVName: "Exportar como PDF",
                },
              }}
              // onRowClick={(evt, selectedRow: any) =>
              //   setSelectedRow(selectedRow.tableData.id)
              // }
              options={{
                // rowStyle: (rowData) => ({
                //   backgroundColor: rowData.id === hoveringOver ? "#0471ff" : "",
                // }),

                exportButton: {
                  csv: true,
                },
                exportCsv: (data, columns) => exportPDF(data, columns),
                filtering: true,
                emptyRowsWhenPaging: false,
                tableLayout: "auto",
                pageSize: 20,
                // rowStyle: (rowData) => ({
                //   backgroundColor:
                //     selectedRow === rowData.tableData.id ? "#EEE" : "#FFF",
                // }),
              }}
              columns={[
                {
                  title: "Pessoa Jurídica",
                  field: "entidade.id",
                  lookup: pessoasJuridicas,
                  cellStyle: {
                    width: "15%",
                  },
                  render: (element) => {
                    return (
                      <Link
                        to={`/interbrasil/pessoas-juridicas/${
                          element.tipo_documento === 1
                            ? "cobranca"
                            : "repasse-taxas"
                        }?pj=${element.entidade?.id}&contrato=${
                          element.contrato?.id
                        }&ano=${element.ano_competencia}`}
                      >
                        {element.entidade?.nm_entidade}
                      </Link>
                    );
                  },
                },
                {
                  title: "Operadora",
                  field: "operadora.id",
                  lookup: operadoras,
                  cellStyle: {
                    width: "15%",
                  },
                  render: (element) => {
                    return (
                      <Link
                        to={`/interbrasil/pessoas-juridicas/${
                          element.tipo_documento === 1
                            ? "cobranca"
                            : "repasse-taxas"
                        }?pj=${element.entidade?.id}&contrato=${
                          element.contrato?.id
                        }&ano=${element.ano_competencia}`}
                      >
                        {element.operadora?.nm_operadora}
                      </Link>
                    );
                  },
                },
                {
                  title: "Mês",
                  field: "mes_competencia",
                  lookup: months,
                  cellStyle: {
                    width: "14%",
                  },
                  render: (element) => {
                    return (
                      <Link
                        to={`/interbrasil/pessoas-juridicas/${
                          element.tipo_documento === 1
                            ? "cobranca"
                            : "repasse-taxas"
                        }?pj=${element.entidade?.id}&contrato=${
                          element.contrato?.id
                        }&ano=${element.ano_competencia}`}
                      >
                        {meses[element.mes_competencia - 1]}
                      </Link>
                    );
                  },
                },
                {
                  title: "Ano",
                  field: "ano_competencia",
                  lookup: years,
                  cellStyle: {
                    width: "14%",
                  },
                  render: (element) => {
                    return (
                      <Link
                        to={`/interbrasil/pessoas-juridicas/${
                          element.tipo_documento === 1
                            ? "cobranca"
                            : "repasse-taxas"
                        }?pj=${element.entidade?.id}&contrato=${
                          element.contrato?.id
                        }&ano=${element.ano_competencia}`}
                      >
                        {element.ano_competencia}
                      </Link>
                    );
                  },
                },
                {
                  title: "Valor",
                  field: "valor",
                  cellStyle: {
                    width: "10%",
                  },
                  render: (element) => {
                    return (
                      <Link
                        to={`/interbrasil/pessoas-juridicas/${
                          element.tipo_documento === 1
                            ? "cobranca"
                            : "repasse-taxas"
                        }?pj=${element.entidade?.id}&contrato=${
                          element.contrato?.id
                        }&ano=${element.ano_competencia}`}
                      >
                        {element.valor ? (
                          <>
                            <Text display="flex" gridColumnGap="3px">
                              <span>R$</span>
                              <NumberFormat
                                readOnly
                                decimalScale={2}
                                decimalSeparator=","
                                fixedDecimalScale
                                thousandSeparator="."
                                value={element.valor}
                                style={{
                                  width: "max-content",
                                  background: "none",
                                }}
                              />
                            </Text>
                          </>
                        ) : (
                          <Text paddingLeft="20px">-</Text>
                        )}
                      </Link>
                    );
                  },
                },
                {
                  title: "Status",
                  field: "status_documento.id",
                  lookup: statusValue,
                  cellStyle: {
                    width: "18%",
                  },
                  render: (element) => {
                    return (
                      <Link
                        to={`/interbrasil/pessoas-juridicas/${
                          element.tipo_documento === 1
                            ? "cobranca"
                            : "repasse-taxas"
                        }?pj=${element.entidade?.id}&contrato=${
                          element.contrato?.id
                        }&ano=${element.ano_competencia}`}
                      >
                        <Alert
                          padding="5px"
                          backgroundColor="unset"
                          status={
                            (element.status_documento?.id === 2 &&
                              moment().format("YYYY/MM/DD") <=
                                moment(
                                  `${element.ano_competencia}-${element.mes_competencia}-${element.contrato.dia_limite_ext_bol_not}`,
                                ).format("YYYY/MM/DD")) ||
                            element.status_documento?.id === 9
                              ? "info"
                              : element.status_documento?.id === 5
                              ? element.fl_pendencia_ext_bol_not
                                ? "info"
                                : "success"
                              : element.status_documento?.id === 3
                              ? "error"
                              : element.status_documento?.id === 4 ||
                                element.status_documento?.id === 10
                              ? "success"
                              : "warning"
                          }
                        >
                          <AlertIcon />
                          {element.status_documento.status}
                        </Alert>
                      </Link>
                    );
                  },
                },
                {
                  title: "Vencimento",
                  field: "dt_vencimento",
                  // sorting: false,
                  cellStyle: {
                    width: "14%",
                  },
                  render: (element) => {
                    return (
                      <Link
                        to={`/interbrasil/pessoas-juridicas/${
                          element.tipo_documento === 1
                            ? "cobranca"
                            : "repasse-taxas"
                        }?pj=${element?.entidade?.id}&contrato=${
                          element?.contrato?.id
                        }&ano=${element.ano_competencia}`}
                      >
                        {element.dt_vencimento}
                      </Link>
                    );
                  },
                },
              ]}
            />
          </Box>
        )}
      </Box>
    </>
  );
};

export default PainelControleInter;
